// extracted by mini-css-extract-plugin
export default {"wrapper":"lJ4NKMwSqtBUHxmDn2Qg","loadingContainer":"YhFnY8L1qmjgHGGgvYrZ","laoderIcon":"zlcWJ_M7MyqaHD7pHcoO","contentWrapper":"JHlolmgVbhqbcRLAexRf","form":"AWEE88cH4ZnzUfZ3koKG"};